

















import {Component, Vue} from 'vue-property-decorator'
import {namespace} from 'vuex-class'

import {RefundStatus} from '@/store/modules/taxrefund/types'

import BeforeAnalysis from './components/BeforeAnalysis.vue'
import Analyzing from './components/Analyzing.vue'
import RefundConfirmation from './components/RefundConfirmation.vue'
import BeforeSurvey from './components/BeforeSurvey.vue'
import RequestCompleted from './components/RequestCompleted.vue'
import Investigation from './components/Investigation.vue'

const taxrefund = namespace('taxrefund')

@Component({
  components: {
    BeforeAnalysis,
    Analyzing,
    RefundConfirmation,
    BeforeSurvey,
    RequestCompleted,
    Investigation,
  }
})
export default class RefundCard extends Vue {
  @taxrefund.Getter('getRefundStatus') getRefundStatus: RefundStatus

  isBeforeAnalysis() {
    return this.getRefundStatus === RefundStatus.환급급조회전 || this.getRefundStatus === RefundStatus.에러
  }

  isAnalyzing() {
    return this.getRefundStatus === RefundStatus.환급급조회중
  }

  isRefundConfirmation() {
    return this.getRefundStatus === RefundStatus.환급급확인전 || this.getRefundStatus === RefundStatus.환급급확인 || this.getRefundStatus === RefundStatus.환급급신청 || this.getRefundStatus === RefundStatus.기장상담신청
  }

  isBeforeSurvey() {
    return this.getRefundStatus === RefundStatus.설문작성대기
  }

  isRequestCompleted() {
    return this.getRefundStatus === RefundStatus.확정진단중 || this.getRefundStatus === RefundStatus.접수준비중
  }

  isInvestigation() {
    return this.getRefundStatus === RefundStatus.국세청환급대기 || this.getRefundStatus === RefundStatus.환급완료
  }
}
